import Aos from "aos";
import "aos/dist/aos.css";
import React, { Component, useEffect } from "react";
import "./services.css";
import pic4 from "../img/pic4.jpg";
import pic5 from "../img/pic5.jpg";
import pic6 from "../img/pic6.jpeg";
import pic7 from "../img/pic7.jpg";
import pic8 from "../img/pic8.jpeg";
import pic10 from "../img/pic10.jpg";

function Services() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <section className="services-section" id="services">
      <div className="container">
        <h2> Our Services</h2>
        <p className="description">
          Al Tatweer Engineering Company provides a variety of services that
          include engineering, project management, design, engineering
          consultancies, and is distinguished by its creative and unique
          solutions that it provides to clients by integrating technical
          expertise and management skills enhanced by the spirit of innovation
          and renewal.{" "}
        </p>
        <div className="card-wrapper grid-1">
          <div className="card">
            <img className="icon" src={pic4} alt="" />
            <h3 className="title">Project Management </h3>
            {/* <p className="description-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odit
              nobis libero earum.
            </p> */}
          </div>
          <div className=" card">
            <img className="icon" src={pic5} alt="" />
            <h3 className="title">Architectural Works</h3>
            {/* <p className="description-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odit
              nobis libero earum.
            </p> */}
          </div>
          <div className=" card">
            <img className="icon" src={pic6} alt="" />
            <h3 className="title">Construction Works</h3>
            {/* <p className="description-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odit
              nobis libero earum.
            </p> */}
          </div>

          <div className=" card">
            <img className="icon" src={pic7} alt="" />
            <h3 className="title">Petroleum </h3>
            {/* <p className="description-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odit
              nobis libero earum.
            </p> */}
          </div>

          <div className=" card">
            <img className="icon" src={pic8} alt="" />
            <h3 className="title">Maga Project</h3>
            {/* <p className="description-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odit
              nobis libero earum.
            </p> */}
          </div>

          <div className=" card">
            <img className="icon" src={pic10} alt="" />
            <h3 className="title">Trading</h3>
            {/* <p className="description-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odit
              nobis libero earum.
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
